const VisionPage = (props) => {
  return <div>Our Vision</div>;
};

VisionPage.propTypes = {};

export default VisionPage;
